import React from 'react';
import { bugsnagClient } from './initObservability';

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  // Guard against hot reload where bugsnagClient might not be initialized
  if (!bugsnagClient) {
    return <>{children}</>;
  }

  const BugsnagReactPlugin = bugsnagClient.getPlugin('react');
  const BugsnagPlugin = BugsnagReactPlugin
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      BugsnagReactPlugin.createErrorBoundary(React as any)
    : null;

  if (!BugsnagPlugin) {
    return <>{children}</>;
  }

  return <BugsnagPlugin>{children}</BugsnagPlugin>;
};
